import request from '@/utils/request'

// 管径相关接口
// 创建管径
export function CreatePipeDiameter(params: {
  name: string
  size: number
  price: number
}) {
  return request({
    url: '/base_data/pipe-diameters',
    method: 'post',
    data: params
  })
}

// 更新管径
export function UpdatePipeDiameter(params: {
  id: number
  name?: string
  size?: number
  price?: number
}) {
  const { id, ...data } = params
  return request({
    url: `/base_data/pipe-diameters/${id}`,
    method: 'put',
    data
  })
}

// 删除管径
export function DeletePipeDiameter(params: { id: number }) {
  return request({
    url: `/base_data/pipe-diameters/${params.id}`,
    method: 'delete'
  })
}

// 获取管径列表
export function ListPipeDiameters() {
  return request({
    url: '/base_data/pipe-diameters',
    method: 'get',
  })
}

// 管材相关接口
// 创建管材
export function CreatePipeMaterial(params: {
  name: string
}) {
  return request({
    url: '/base_data/pipe-materials',
    method: 'post',
    data: params
  })
}

// 更新管材
export function UpdatePipeMaterial(params: {
  id: number
  name?: string
}) {
  const { id, ...data } = params
  return request({
    url: `/base_data/pipe-materials/${id}`,
    method: 'put',
    data
  })
}

// 删除管材
export function DeletePipeMaterial(params: { id: number }) {
  return request({
    url: `/base_data/pipe-materials/${params.id}`,
    method: 'delete'
  })
}

// 获取管材列表
export function ListPipeMaterials() {
  return request({
    url: '/base_data/pipe-materials',
    method: 'get',
  })
}

// 路面相关接口
// 创建路面
export function CreateRoadSurface(params: {
  name: string
}) {
  return request({
    url: '/base_data/road-surfaces',
    method: 'post',
    data: params
  })
}

// 更新路面
export function UpdateRoadSurface(params: {
  id: number
  name?: string
}) {
  const { id, ...data } = params
  return request({
    url: `/base_data/road-surfaces/${id}`,
    method: 'put',
    data
  })
}

// 删除路面
export function DeleteRoadSurface(params: { id: number }) {
  return request({
    url: `/base_data/road-surfaces/${params.id}`,
    method: 'delete'
  })
}

// 获取路面列表
export function ListRoadSurfaces() {
  return request({
    url: '/base_data/road-surfaces',
    method: 'get',
  })
}

// 漏水部位相关接口
// 创建漏水部位
export function CreateLeakPosition(params: {
  name: string
}) {
  return request({
    url: '/base_data/leak-positions',
    method: 'post',
    data: params
  })
}

// 更新漏水部位
export function UpdateLeakPosition(params: {
  id: number
  name?: string
}) {
  const { id, ...data } = params
  return request({
    url: `/base_data/leak-positions/${id}`,
    method: 'put',
    data
  })
}

// 删除漏水部位
export function DeleteLeakPosition(params: { id: number }) {
  return request({
    url: `/base_data/leak-positions/${params.id}`,
    method: 'delete'
  })
}

// 获取漏水部位列表
export function ListLeakPositions() {
  return request({
    url: '/base_data/leak-positions',
    method: 'get',
  })
}

// 漏水原因相关接口
// 创建漏水原因
export function CreateLeakReason(params: {
  desc: string
}) {
  return request({
    url: '/base_data/leak-reasons',
    method: 'post',
    data: params
  })
}

// 更新漏水原因
export function UpdateLeakReason(params: {
  id: number
  desc?: string
}) {
  const { id, ...data } = params
  return request({
    url: `/base_data/leak-reasons/${id}`,
    method: 'put',
    data
  })
}

// 删除漏水原因
export function DeleteLeakReason(params: { id: number }) {
  return request({
    url: `/base_data/leak-reasons/${params.id}`,
    method: 'delete'
  })
}

// 获取漏水原因列表
export function ListLeakReasons() {
  return request({
    url: '/base_data/leak-reasons',
    method: 'get',
  })
}
